module.exports = __webpack_public_path__ + "static/AfricaMap-a8419da0cde9b73521bc8a561f8d679e.svg";